<template>
  <li
    :id="id"
    class="tab-switch"
    :class="active ? 'active' : ''"
    @click="onClick(id)"
  >
    <span v-if="unread" class="unread-mark" />
    <span>{{ title }}</span>
  </li>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    id: {
      type: String,
      required: true
    },
    active: {
      type: Boolean,
      required: false,
      default: false
    },
    unread: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  methods: {
    onClick(value) {
      this.$emit('click-tab-switch', value)
    }
  }
}
</script>
<style lang="scss" scoped>
.tab-switch {
  @extend %caption-bold;
  flex: 1;
  padding: 16px 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: $gray-2 2px solid;

  &.active {
    color: $primary;
    border-bottom: $primary 2px solid;
  }
}
.unread-mark {
  display: inline-block;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: $danger;
  margin-right: 8px;
}
</style>
